import { Accordion } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Accordion)`
  background: ${(p) => p.theme.palette.common.white};
  /* width: ${(p) => p.theme.spacing(60)}; */
  border-radius: ${(p) => p.theme.spacing(1)};
  border: 1px solid ${(p) => p.theme.palette.grey[300]};
  margin-bottom: ${(p) => p.theme.spacing(1)};

  &::before {
    display: none;
  }

  &.Mui-expanded {
    margin-bottom: ${(p) => p.theme.spacing(1)};
    box-shadow: none;
  }
`;
